// extracted by mini-css-extract-plugin
export default {"root":"ProductLinkageModal_root__AiS+z","titleModal":"ProductLinkageModal_titleModal__r9Eke"};